import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  privacyPolicy: {
    id: 'studio.cPwv2c',
    defaultMessage: 'Privacy policy',
  },
});
